import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../../../mesc/mesc.service';
import { COLSAdminOwnerInfo } from '../../../camtl.config';

@Component({
  selector: 'cols-admin',
  templateUrl: './cols-admin.component.html',
  styleUrls: ['./cols-admin.component.scss']
})
export class ColsAdminComponent implements OnInit {

  constructor(private service: BaseService) {
    this.ownerName = COLSAdminOwnerInfo.NAME;
    this.ownerEmail = COLSAdminOwnerInfo.EMAIL;
  }

  ownerName: string;
  ownerEmail: string;

  ngOnInit() {

  }

  onRead = () => {
    return this.service.read("group/MESC_CAMTL_COLSAdmin/user", true);
  }

  columns = [
    {
      field: "GMIN",
      title: "",
      width: 55,
      template: {
        type: 'person'
      }
    },
    {
      field: "FirstName",
      title: "First Name",
    },
    {
      field: "LastName",
      title: "Last Name"
    },
    {
      field: "Email",
      title: "Email",
      template: {
        type: 'email',
      }
    },
    {
      field: "Phone",
      title: "Phone"
    }
  ];

  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      width: 1
    },
    columns: this.columns,
    service: this.service,
    read: this.onRead
  }

}
